import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Utils } from '../utils';
import { UserContext } from '../_models/user-context';

@Injectable()
export class AuthAmministratoreGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (Utils.isUserLogged()) {
            if (Utils.isUtenteAmministratore()) return true;

            // not logged in so redirect to login page with the return url
            this.router.navigate([Utils.getRedirectHomepage()]);
            return false;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/_guard/auth-amministratore.guard.ts